<template>
  <v-container grid-list-xl>
    <v-layout justify-center row wrap>
      <v-flex xs12>
        <w-main-title
          class="pb-0 mb-0"
          title="Presupuestos"
          :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-flex>
      <v-flex xs12 class="text-right">
        <v-btn class="secondary" small outlined @click="createNewQuotation">
          Nuevo Presupuesto
          <v-icon right size="14">fas fa-calculator</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 md4 class="pt-0">
        <v-text-field
          clearable
          prepend-icon="fas fa-user"
          v-model="term"
          label="Paciente"
          hint="Nombre, Apellido o Correo"
        ></v-text-field>
        <date-picker label="Fecha Desde" ref="from"></date-picker>
        <date-picker label="Fecha Hasta" ref="to"></date-picker>
        <v-btn
          block
          outlined
          color="primary"
          small
          @click="applyFilters"
          :loading="consulting"
          >Aplicar Filtro</v-btn
        >
      </v-flex>
      <v-flex xs12 md8>
        <v-layout row wrap>
          <v-layout row wrap v-if="loadingQuotationFromApi">
            <v-flex xs12 class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs12 v-if="filteredQuotations.length === 0">
              <h3 class="font-weight-light text-center mt-4">
                No hay presupuestos ingresados
              </h3>
            </v-flex>
            <template v-else>
              <v-flex
                xs12
                sm6
                v-for="item in filteredQuotations"
                :key="item.uuid"
              >
                <quotation-list-item
                  text="Creado el"
                  :item="item"
                  :services="servicesItems"
                  :user="item.client"
                  @clicked="openModal(item)"
                ></quotation-list-item>
              </v-flex>
            </template>

            <v-flex xs12>
              <item-counter
                :length="filteredQuotations.length"
                :total="totalItems"
              ></item-counter>
              <next-page-btn
                :loading="consulting"
                v-if="nextPageUrl"
                :nextFn="loadNextPage"
              ></next-page-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="modalQuotationTemplate"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dense color="primary" dark depressed fixed>
          <v-toolbar-title>Ingreso de Presupuesto</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="closeQuotationModal">
              Cerrar
            </v-btn>
            <v-btn
              text
              class="primary"
              :loading="creatingQuotation"
              @click="saveQuotationTemplate"
              >Guardar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <quotation-template
            ref="quotationTemplate"
            :template="quotationTemplate"
            :servicesItems="servicesItems"
            :isFromTemplate="isFromTemplate"
          ></quotation-template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalQuotationData" max-width="400px">
      <v-card>
        <v-card-text>
          <quotation-modal-info
            ref="quotationModal"
            text="Creado el"
            :showStatus="false"
            :showDetails="true"
            :services="servicesItems"
            :disabled="quotationSelected.quoted"
            :quotation="quotationSelected"
          ></quotation-modal-info>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import { queryFilterBuilder } from '@/utils/Shared'

export default {
  components: {
    WMainTitle: () => import('@/components/common/WMainTitle'),
    QuotationTemplate: () =>
      import('@/components/providers/quotations/QuotationTemplate'),
    QuotationListItem: () =>
      import('@/components/providers/quotations/QuotationListItem'),
    QuotationModalInfo: () =>
      import('@/components/providers/quotations/QuotationModalInfo'),
    DatePicker: () => import('@/components/common/DatePicker'),
    NextPageBtn: () => import('@/components/common/NextPageBtn'),
    ItemCounter: () => import('@/components/common/ItemCounter')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Presupuestos Realizados',
          disabled: true,
          href: ''
        }
      ],
      modalQuotationTemplate: false,
      quotationTemplate: null,
      servicesItems: [],
      isFromTemplate: false,
      quotations: [],
      services: [],
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
      nextPageUrl: null,
      consulting: false,
      loadingQuotationFromApi: false,
      itemURL: 'quotations',
      quotationSelected: {},
      modalQuotationData: false,
      //filters
      term: ''
    }
  },
  async created() {
    this.servicesItems = await this.$store.dispatch(
      'quotations/loadProviderServices',
      { providerId: this.providerData[0].id }
    )
  },
  async mounted() {
    if (this.providerData.length > 0) {
      const url = `provider/${this.providerData[0].id}/quotations`
      await this.initilize(url)
    }
  },
  watch: {
    modalQuotationData: function(val1, val2) {
      if (val1 === true && val2 === false && !!this.$refs.quotationModal) {
        this.$refs.quotationModal.segment = 'paciente'
      }
    }
  },
  computed: {
    creatingQuotation() {
      return this.$store.getters['quotations/creatingQuotation']
    },
    providerData() {
      return this.$store.getters.currentUser.service_providers
    },
    filteredQuotations() {
      if (this.quotations.length === 0) return []
      const mapped = this.quotations.map(item => {
        item.quotationListed = true
        item.isServiceItem = item.service_items.length > 0
        item.isSpecialSale = !!item.special_sale
        const c = item.client
        const idxs = [
          'first_name',
          'last_name',
          'mother_last_name',
          'dni',
          'address',
          'commune_id',
          'phone1',
          'phone2'
        ]
        idxs.forEach(el => {
          c[el] ? (c[el] = c[el]) : (c[el] = item['client_' + el.toString()])
        })
        c['dni'] = c['dni'].replace(/\.|\,|\-/g, '').toUpperCase()
        return item
      })
      return mapped
    }
  },
  methods: {
    async initilize(url) {
      try {
        this.loadingQuotationFromApi = true
        const initialized = await this.$store.dispatch(
          'quotations/initialLoad',
          {
            url,
            itemURL: this.itemURL
          }
        )
        if (initialized.ok) {
          const pageData = initialized.pageData
          this.loadPageData(pageData)
          this.services = initialized.services
        }
      } catch (err) {

      } finally {
        this.loadingQuotationFromApi = false
      }
    },
    async applyFilters() {
      const filters = {
        term: this.term,
        start_date: this.$refs.from.date,
        end_date: this.$refs.to.date
      }
      const query = queryFilterBuilder(filters)
      this.consulting = true
      let url = ''
      if (query.ok)
        url = `provider/${this.providerData[0].id}/quotations?${query.query}`
      else url = `provider/${this.providerData[0].id}/quotations`
      await this.initilize(url)
      this.consulting = false
    },
    loadPageData(payload) {
      this.currentPage = payload.currentPage || 0
      this.totalItems = payload.totalItems || 0
      this.nextPageUrl = payload.nextPageUrl || null
      this.quotations = payload.quotations || []
    },
    async loadNextPage() {
      if (this.nextPageUrl === null) return
      this.consulting = true
      try {
        const pageData = await this.$store.dispatch('quotations/loadNextPage', {
          nextPageUrl: this.nextPageUrl,
          itemURL: this.itemURL,
          actual: this.quotations
        })
        this.loadPageData(pageData)
      } catch (error) {

      } finally {
        setTimeout(() => {
          this.consulting = false
        }, 1000)
      }
    },
    async createNewQuotation() {
      this.servicesItems = await this.$store.dispatch(
        'quotations/loadProviderServices',
        { providerId: this.providerData[0].id }
      )
      this.isFromTemplate = false
      this.quotationTemplate = {
        items: [],
        client: []
      }
      this.openQuotationModal()
    },
    async saveQuotationTemplate() {
      const r = this.$refs.quotationTemplate.saveQuotation()
      const quotationSend = await this.$store.dispatch(
        'quotations/saveNewQuotation',
        {
          providerId: this.$store.getters.currentUser.service_providers[0].id,
          data: r,
          isFromTemplate: false,
          quotationSelected: null,
          successMessage: 'Presupuesto Creado'
        }
      )
      if (quotationSend.ok) {
        this.quotations.unshift(quotationSend.payload)
        this.totalItems++
        this.closeQuotationModal()
      }
    },
    openQuotationModal() {
      this.modalQuotationTemplate = true
      setTimeout(() => {
        this.$refs.quotationTemplate.initModal()
      }, 200)
    },
    async closeQuotationModal() {
      this.$refs.quotationTemplate.cleanItems()
      this.servicesItems = await this.$store.dispatch(
        'quotations/loadProviderServices',
        { providerId: this.providerData[0].id }
      )
      this.modalQuotationTemplate = false
    },
    openModal(item) {
      this.quotationSelected = item
      this.modalQuotationData = true
    }
  }
}
</script>
